import { Command } from "./command.js";
/**
 * @see https://redis.io/commands/lmove
 */
export class LMoveCommand extends Command {
    constructor(cmd, opts) {
        super(["lmove", ...cmd], opts);
    }
}
